import { isArray, map } from "lodash";
import { Text } from "orcs-design-system";
import React from "react";
import { Node } from "slate";

const toPlainText = (richTextContent) => {
  if (richTextContent == null) {
    return "";
  }
  // Seed/workspace configs sometimes store details as a literal string.
  // Slate Node.string() expects a node with children and crashes otherwise.
  if (typeof richTextContent === "string") {
    return richTextContent;
  }
  if (isArray(richTextContent)) {
    return map(richTextContent, toPlainText).join("\n");
  }
  try {
    return Node.string(richTextContent);
  } catch {
    return "";
  }
};

export const isRichTextContentEmpty = (richTextContent) => {
  return toPlainText(richTextContent).trim() === "";
};

export const parseLeaf = (obj, styles = {}) => {
  const { text, bold, italic, underline } = obj;

  if (!text) {
    return null;
  }

  let component = <span>{text}</span>;

  if (bold) {
    component = <strong>{component}</strong>;
  }

  if (italic) {
    component = <em>{component}</em>;
  }

  if (underline) {
    component = <u>{component}</u>;
  }

  return <Text {...styles}>{component}</Text>;
};
